import { SignInActions, SignInSteps } from 'authOld/constants';
import {
  IAuthUserForm,
  ICreatePasswordForm,
  ISetUpAccountForm,
  ISignUpForm,
  ISwitchUsersForm,
  ITermsAndPrivacy,
} from 'authOld/types';
import { IAddress } from 'coreOld/types';
import { isObject, objectKeysCamelToSnakeCase } from 'coreOld/utils';

export const mapSignInForm = (data: IAuthUserForm, step: SignInSteps, redirectUrl?: string) => {
  switch (step) {
    case SignInSteps.EMAIL:
      return {
        email: data.email,
        signin_action: SignInActions.RESOLVE_ACCOUNT_TYPE,
        redirect_url: redirectUrl,
      };
    case SignInSteps.PASSWORD:
      return {
        email: data.email,
        password: data.password,
        signin_action: SignInActions.AUTHENTICATE,
        // Sent on this step too: the server keeps no state between the two, so
        // it can only echo back a target it was given on the step it answers.
        redirect_url: redirectUrl,
      };
    default:
      return {};
  }
};

export const mapCreatePasswordForm = (data: ICreatePasswordForm) => ({
  password: data.password,
  password_confirm: data.confirmPassword,
});

export const mapSignUpForm = (data: ISignUpForm, reCatpchaToken: string) => ({
  email: data.email,
  'g-recaptcha-response': reCatpchaToken,
  version: 2,
});

export const mapSetUpAccountForm = (
  data: ISetUpAccountForm,
  termsAndPrivacyChecked: ITermsAndPrivacy
) => {
  const acceptTc = Object.values(termsAndPrivacyChecked).every((item: boolean) => item);

  return objectKeysCamelToSnakeCase({
    firstName: data.firstName,
    lastName: data.lastName,
    company: data.company,
    acceptTc,
  });
};

export const mapCreateLocationForm = (data: IAddress) => ({
  address: {
    line1: data.line1,
    line2: data.line2,
    country: data.country?.abbreviation,
    state: isObject(data.state) ? data.state?.abbreviation : data.state,
    zip: data.postalCode,
    city: data.city,
    name: data.locationName,
  },
});

export const mapSwitchUsersForm = (data: ISwitchUsersForm) => ({
  impersonated_user_id: data?.user?.id,
});
